import { RankLabels } from "src/app/models/enum";

/** Maps rank code (e.g. fo, sfo, captain) to display label; case-insensitive. */
export function getRankLabel(rank?: string): string {
	if (!rank?.trim()) {
		return "";
	}

	const code = rank.trim().toLowerCase() as keyof typeof RankLabels;
	return RankLabels[code] ?? "";
}
